import {
    Checkbox,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormHelperText,
    FormLabel,
    Grid,
    MenuItem,
    Radio,
    RadioGroup,
    Switch,
    Tab,
    Tabs,
    TextField,
    Tooltip,
    Typography,
} from "@mui/material";
import AsyncSelect from "common/components/AsyncSelect/AsyncSelect";
import DateFieldComponent from "common/components/DateFieldComponent/DateFieldComponent";
import TabPanelComponent from "common/components/TabPanel/TabPanelComponent";
import { ApiService } from "common/services/ApiService";
import { useAuth } from "context/AuthContext";
import React, { useEffect, useState } from "react";
import { VISIBILITY } from "utils/constants";

const DialogContentClone = ({
    activityCloneFormData,
    setActivityCloneFormData,
    selectedActivity,
    showEditableButton = true,
}) => {
    const { auth } = useAuth();
    const [defaultDataset, setDefaultDataset] = useState(null);
    const [visibility, setVisibility] = useState(selectedActivity.visibility);
    const [visibilityDataset, setVisibilityDataset] = React.useState(
        selectedActivity?.staticDataSource
            ? selectedActivity?.staticDataSource?.visibility
            : VISIBILITY.public
    );
    const [datasets, setDatasets] = useState([]);
    const [graphAvailableMap, setGraphAvailableMap] = useState({
        dataTable: false,
        column: false,
        line: false,
        pie: false,
        bubble: false,
        dispersion: false,
        map: false,
        static_network: false,
        word_cloud: false,
    });
    const [actualDataset, setActualDataset] = useState({});
    const [valueTab, setValueTab] = useState(
        selectedActivity?.staticDataSource ? "staticDataSource" : "dynamicDataSource"
    );
    const [dynamicDataSourceList, setDynamicDataSoruceList] = useState([]);
    const [editable, setEditable] = useState(false);

    const { bubble, column, line, pie, map, static_network, word_cloud } = graphAvailableMap;

    const handleChangeVisibility = (event) => {
        setVisibility(event.target.value);
        setActivityCloneFormData({
            ...activityCloneFormData,
            visibility: event.target.value,
        });
    };

    const handleChange = (event) => {
        const newGraphs = {
            ...graphAvailableMap,
            [event.target.name]: event.target.checked,
        };
        setGraphAvailableMap(newGraphs);
        setActivityCloneFormData({
            ...activityCloneFormData,
            graphsData: newGraphs,
        });
    };

    const getDatasetsCloneCreate = async (search, visibilityFilter) => {
        const res = await ApiService.getDatasetsCloneCreate({
            hide: false,
            visibility: visibilityFilter,
            establishment:
                auth.selectedRole?.name === "superadmin" ||
                visibilityFilter === VISIBILITY.community
                    ? null
                    : auth.selectedEstablishment?.id || null,
            activity: selectedActivity?.id,
            clone: true,
            no_page: 1,
            search,
        });
        setDatasets(res.data);
        return res.data;
    };

    const handleChangeTab = (event, newValue) => {
        setValueTab(newValue);
    };

    useEffect(() => {
        const fetchDatasets = async () => {
            const graphs = {};
            setActivityCloneFormData({
                ...activityCloneFormData,
                statementTitle: selectedActivity.statement_title,
                statement: selectedActivity.statement,
                title: selectedActivity.title,
                visibility: selectedActivity.visibility,
                description: selectedActivity.description,
                staticDataSource: selectedActivity?.staticDataSource
                    ? selectedActivity?.staticDataSource?.id
                    : null,
                dynamicDataSource: selectedActivity?.staticDataSource
                    ? null
                    : selectedActivity?.dynamicDataSource?.id,
            });
            if (selectedActivity.graphs.length > 0) {
                selectedActivity.graphs.forEach((g) => (graphs[g] = true));
                setGraphAvailableMap(graphs);
            }

            const datasetsResult = await searchAsyncSelect(selectedActivity?.title || "");
            setDefaultDataset(datasetsResult[0]);
            setActualDataset(datasetsResult[0]);
        };

        fetchDatasets(); // Llama a la función asíncrona dentro del useEffect
        getDynamicDataSource();
    }, []);

    const searchAsyncSelect = async (search) => {
        if (search === "") {
            setDatasets([]);
            return [];
        }
        const result = await getDatasetsCloneCreate(search, visibilityDataset);
        return result;
    };

    const handleChangeVisibilityDataset = (event) => {
        setVisibilityDataset(event.target.value);
    };

    const getDynamicDataSource = async (search, visibilityFilter) => {
        const res = await ApiService.getDynamicDataSources();
        setDynamicDataSoruceList(res.data);
    };

    return (
        <>
            {showEditableButton && (
                <FormControlLabel
                    control={
                        <Switch
                            checked={editable}
                            onChange={(evt) => setEditable(evt.target.checked)}
                            name="editable"
                        />
                    }
                    label={`${editable ? "Deshabilitar" : "Habilitar"} edición`}
                />
            )}
            <FormControl fullWidth margin="normal">
                <TextField
                    autoFocus
                    required
                    margin="normal"
                    id="title"
                    fullWidth
                    label="Título de la actividad"
                    type="text"
                    value={activityCloneFormData.title}
                    disabled={!showEditableButton || !editable}
                    inputProps={{ maxLength: 100 }}
                    onChange={(evt) => {
                        setActivityCloneFormData({
                            ...activityCloneFormData,
                            title: evt.target.value,
                        });
                    }}
                />
                <FormHelperText sx={{ textAlign: "right" }}>
                    {`${activityCloneFormData?.title?.length} / 100`}
                </FormHelperText>
            </FormControl>

            {!showEditableButton && (
                <FormControl fullWidth margin="normal">
                    <DateFieldComponent
                        variant={"outlined"}
                        disabled
                        defaultValue={selectedActivity?.datetimeAdded}
                        label={"Fecha de creación"}
                        handleChange={(evt) => {}}
                    ></DateFieldComponent>
                </FormControl>
            )}

            {!showEditableButton && (
                <FormControl fullWidth margin="normal">
                    <TextField
                        variant={"outlined"}
                        required
                        margin="normal"
                        id="objetive"
                        fullWidth
                        label="Creador"
                        type="text"
                        disabled
                        multiline
                        maxRows={6}
                        value={selectedActivity?.owner?.email}
                    />
                </FormControl>
            )}

            {!showEditableButton && Object.keys(selectedActivity?.parent || {}).length > 0 && (
                <FormControl fullWidth margin="normal">
                    <TextField
                        variant={"outlined"}
                        required
                        margin="normal"
                        id="objetive"
                        fullWidth
                        label="Derivada de la actividad"
                        type="text"
                        disabled
                        multiline
                        maxRows={6}
                        value={`${selectedActivity?.parent?.title} (Creada por: ${selectedActivity?.parent?.owner?.email})`}
                    />
                </FormControl>
            )}

            <h5>Enunciado</h5>
            <Grid
                container
                sx={{
                    display: "flex",
                    justifyContent: "right",
                }}
            >
                <Grid item xs={11}>
                    <FormControl fullWidth margin="normal">
                        <TextField
                            required
                            disabled={!showEditableButton || !editable}
                            margin="normal"
                            id="statementTitle"
                            fullWidth
                            value={activityCloneFormData?.statementTitle}
                            label="Título del enunciado"
                            type="text"
                            inputProps={{ maxLength: 100 }}
                            onChange={(evt) => {
                                setActivityCloneFormData({
                                    ...activityCloneFormData,
                                    statementTitle: evt.target.value,
                                });
                            }}
                        />
                        <FormHelperText sx={{ textAlign: "right" }}>
                            {`${activityCloneFormData?.statementTitle?.length} / 100`}
                        </FormHelperText>
                    </FormControl>
                    <FormControl fullWidth margin="normal">
                        <TextField
                            required
                            disabled={!showEditableButton || !editable}
                            margin="normal"
                            id="statement"
                            fullWidth
                            value={activityCloneFormData?.statement}
                            label="Enunciado"
                            InputLabelProps={{ shrink: true }}
                            placeholder="Incluya aquí la consigna o tarea que debe realizar el estudiante"
                            type="text"
                            multiline
                            rows={4}
                            maxRows={6}
                            inputProps={{ maxLength: 1000 }}
                            onChange={(evt) => {
                                setActivityCloneFormData({
                                    ...activityCloneFormData,
                                    statement: evt.target.value,
                                });
                            }}
                        />
                        <FormHelperText sx={{ textAlign: "right" }}>
                            {`${activityCloneFormData?.statement?.length} / 1000`}
                        </FormHelperText>
                    </FormControl>
                </Grid>
            </Grid>
            <FormControl>
                <FormLabel id="visilibty">Visibilidad actividad</FormLabel>
                <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    value={visibility}
                    onChange={handleChangeVisibility}
                >
                    <FormControlLabel
                        disabled={!showEditableButton}
                        value={VISIBILITY.public}
                        control={<Radio />}
                        label="Establecimiento"
                    />
                    <FormControlLabel
                        disabled={!showEditableButton}
                        value={VISIBILITY.private}
                        control={<Radio />}
                        label="Privado"
                    />
                    <FormControlLabel
                        disabled={!showEditableButton}
                        value={VISIBILITY.community}
                        control={<Radio />}
                        label="Comunidad"
                    />
                </RadioGroup>
            </FormControl>
            <FormControl fullWidth margin="normal">
                <TextField
                    required
                    margin="normal"
                    id="objetive"
                    fullWidth
                    label="Objetivo de la actividad"
                    type="text"
                    disabled={!showEditableButton || !editable}
                    multiline
                    rows={4}
                    maxRows={6}
                    value={activityCloneFormData.objetive}
                    defaultValue={selectedActivity.objetive}
                    inputProps={{ maxLength: 1000 }}
                    onChange={(evt) => {
                        setActivityCloneFormData({
                            ...activityCloneFormData,
                            objetive: evt.target.value,
                        });
                    }}
                />
                <FormHelperText sx={{ textAlign: "right" }}>
                    {`${selectedActivity.objetive?.length} / 1000`}
                </FormHelperText>
            </FormControl>
            <FormControl fullWidth margin="normal">
                <TextField
                    required
                    margin="normal"
                    id="description"
                    fullWidth
                    defaultValue={selectedActivity.description}
                    label="Descripción de la actividad"
                    type="text"
                    disabled={!showEditableButton || !editable}
                    value={activityCloneFormData.description}
                    InputLabelProps={{ shrink: true }}
                    placeholder={
                        "Incluya aquí la descripción de la actividad, por ejemplo, el contexto de la actividad (el tema que se aborda y porqué), que se espera que aprenda o desarrolle el estudiante, si es una tarea grupal o individual, cómo se relaciona con los contenidos que se trabajaron previamente y cuáles son los criterios de evaluación"
                    }
                    multiline
                    rows={5}
                    maxRows={6}
                    inputProps={{ maxLength: 1000 }}
                    onChange={(evt) => {
                        setActivityCloneFormData({
                            ...activityCloneFormData,
                            description: evt.target.value,
                        });
                    }}
                />
                <FormHelperText sx={{ textAlign: "right" }}>
                    {`${selectedActivity.description?.length} / 1000`}
                </FormHelperText>
            </FormControl>

            <div
                style={{
                    border: "1px solid #C0C0C0",
                    borderRadius: 2,
                    marginBottom: 15,
                    marginTop: 15,
                }}
            >
                <Tabs value={valueTab} onChange={handleChangeTab} aria-label="basic tabs example">
                    <Tab
                        disabled={valueTab === "dynamicDataSource"}
                        label="Fuentes estáticas"
                        value="staticDataSource"
                    />
                    <Tab
                        disabled={valueTab === "staticDataSource"}
                        label="Fuentes dinámicas"
                        value="dynamicDataSource"
                    />
                </Tabs>

                <TabPanelComponent value={valueTab} index={"staticDataSource"}>
                    <div
                        style={{
                            padding: "12px 18px",
                        }}
                    >
                        <FormControl disabled={!showEditableButton || !editable}>
                            <Typography style={{ color: "#787E8F" }}>
                                Filtro visibilidad dataset
                            </Typography>
                            <RadioGroup
                                row
                                required
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                                value={visibilityDataset}
                                onChange={handleChangeVisibilityDataset}
                            >
                                <FormControlLabel
                                    value={VISIBILITY.public}
                                    control={<Radio />}
                                    label="Establecimiento"
                                />
                                <FormControlLabel
                                    value={VISIBILITY.private}
                                    control={<Radio />}
                                    label="Privado"
                                />
                                <FormControlLabel
                                    value={VISIBILITY.community}
                                    control={<Radio />}
                                    label="Comunidad"
                                />
                            </RadioGroup>
                        </FormControl>
                        <AsyncSelect
                            disabled={!showEditableButton || !editable}
                            required
                            options={datasets}
                            renderOption={(props, option) => {
                                return (
                                    <li {...props} key={option.id}>
                                        {option.name} {option.parent ? "(Dataset base)" : ""}
                                    </li>
                                );
                            }}
                            optionLabel={(option) => {
                                return `${option.name} ${option.parent ? "(Dataset base)" : ""}`;
                            }}
                            onChangeSearch={async (search) => {
                                searchAsyncSelect(search);
                            }}
                            onChangeSelect={(value) => {
                                setActualDataset(value);
                                setActivityCloneFormData({
                                    ...activityCloneFormData,
                                    staticDataSource: value?.id,
                                });
                            }}
                            label="Búsqueda dataset*"
                            onClose={() => {
                                setDatasets([]);
                            }}
                            defaultValue={defaultDataset}
                        />
                        <FormControl style={{ marginTop: "10px" }}>
                            <FormLabel component="legend">Gráficos permitidos</FormLabel>
                            <FormGroup sx={{ display: "flex", flexDirection: "row" }}>
                                <FormControlLabel
                                    disabled={
                                        (!(actualDataset?.name || "").includes("csv") &&
                                            editable) ||
                                        !editable
                                    }
                                    control={
                                        <Checkbox
                                            checked={column}
                                            onChange={handleChange}
                                            name="column"
                                        />
                                    }
                                    label={
                                        <Tooltip
                                            enterTouchDelay={0}
                                            leaveTouchDelay={15000}
                                            disableTouchListener={false}
                                            title={
                                                <img
                                                    src="/img/charts/Columnas agrupadas.png"
                                                    alt="Columnas agrupadas"
                                                    width="100%"
                                                    // height="20"
                                                />
                                            }
                                        >
                                            <p>Columnas agrupadas</p>
                                        </Tooltip>
                                    }
                                />
                                <FormControlLabel
                                    disabled={
                                        (!(actualDataset?.name || "").includes("csv") &&
                                            editable) ||
                                        !editable
                                    }
                                    control={
                                        <Checkbox
                                            checked={line}
                                            onChange={handleChange}
                                            name="line"
                                        />
                                    }
                                    label={
                                        <Tooltip
                                            enterTouchDelay={0}
                                            leaveTouchDelay={15000}
                                            disableTouchListener={false}
                                            title={
                                                <img
                                                    src="/img/charts/Líneas agrupadas.png"
                                                    alt="Líneas"
                                                    width="100%"
                                                    // height="20"
                                                />
                                            }
                                        >
                                            <p>Líneas</p>
                                        </Tooltip>
                                    }
                                />
                                <FormControlLabel
                                    disabled={
                                        (!(actualDataset?.name || "").includes("csv") &&
                                            editable) ||
                                        !editable
                                    }
                                    control={
                                        <Checkbox
                                            checked={pie}
                                            onChange={handleChange}
                                            name="pie"
                                        />
                                    }
                                    label={
                                        <Tooltip
                                            enterTouchDelay={0}
                                            leaveTouchDelay={15000}
                                            disableTouchListener={false}
                                            title={
                                                <img
                                                    src="/img/charts/Torta.png"
                                                    alt="Torta"
                                                    width="100%"
                                                    // height="20"
                                                />
                                            }
                                        >
                                            <p>Torta</p>
                                        </Tooltip>
                                    }
                                />
                                <FormControlLabel
                                    disabled={
                                        (!(actualDataset?.name || "").includes("csv") &&
                                            editable) ||
                                        !editable
                                    }
                                    control={
                                        <Checkbox
                                            checked={bubble}
                                            onChange={handleChange}
                                            name="bubble"
                                        />
                                    }
                                    label={
                                        <Tooltip
                                            enterTouchDelay={0}
                                            leaveTouchDelay={15000}
                                            disableTouchListener={false}
                                            title={
                                                <img
                                                    src="/img/charts/Burbujas.png"
                                                    alt="Burbujas"
                                                    width="100%"
                                                    // height="20"
                                                />
                                            }
                                        >
                                            <p>Burbujas</p>
                                        </Tooltip>
                                    }
                                />
                                <FormControlLabel
                                    disabled={
                                        (!(actualDataset?.name || "").includes("csv") &&
                                            editable) ||
                                        !editable
                                    }
                                    control={
                                        <Checkbox
                                            checked={map}
                                            onChange={handleChange}
                                            name="map"
                                        />
                                    }
                                    label={
                                        <Tooltip
                                            enterTouchDelay={0}
                                            leaveTouchDelay={15000}
                                            disableTouchListener={false}
                                            title={
                                                <img
                                                    src="/img/charts/Mapa.png"
                                                    alt="Mapa"
                                                    width="100%"
                                                    // height="20"
                                                />
                                            }
                                        >
                                            <p>Mapa</p>
                                        </Tooltip>
                                    }
                                />
                                <FormControlLabel
                                    disabled={
                                        (!(actualDataset?.name || "").includes("csv") &&
                                            editable) ||
                                        !editable
                                    }
                                    control={
                                        <Checkbox
                                            checked={static_network}
                                            onChange={handleChange}
                                            name="static_network"
                                        />
                                    }
                                    label={
                                        <Tooltip
                                            enterTouchDelay={0}
                                            leaveTouchDelay={15000}
                                            disableTouchListener={false}
                                            title={
                                                <img
                                                    src="/img/charts/Grafo.png"
                                                    alt="Grafo"
                                                    width="100%"
                                                    // height="20"
                                                />
                                            }
                                        >
                                            <p>Grafo</p>
                                        </Tooltip>
                                    }
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            disabled={
                                                (!(actualDataset?.name || "").includes("pdf") &&
                                                    editable) ||
                                                !editable
                                            }
                                            checked={word_cloud}
                                            onChange={handleChange}
                                            name="word_cloud"
                                        />
                                    }
                                    label={
                                        <Tooltip
                                            enterTouchDelay={0}
                                            leaveTouchDelay={15000}
                                            disableTouchListener={false}
                                            title={
                                                <img
                                                    src="/img/charts/Nube de palabras.png"
                                                    alt="Nube de palabras"
                                                    width="100%"
                                                    // height="20"
                                                />
                                            }
                                        >
                                            <p>Nube de palabras</p>
                                        </Tooltip>
                                    }
                                />
                            </FormGroup>
                        </FormControl>
                    </div>
                </TabPanelComponent>

                <TabPanelComponent value={valueTab} index={"dynamicDataSource"}>
                    <div
                        style={{
                            padding: "12px 18px",
                        }}
                    >
                        <TextField
                            required
                            select
                            label="Seleccione una fuente dinámica"
                            fullWidth
                            disabled={!showEditableButton || !editable}
                            value={
                                selectedActivity?.staticDataSource
                                    ? ""
                                    : selectedActivity?.dynamicDataSource?.id
                            }
                        >
                            {dynamicDataSourceList.map((province) => (
                                <MenuItem disabled key={province.id} value={province.id}>
                                    {province.label}
                                </MenuItem>
                            ))}
                        </TextField>
                    </div>
                </TabPanelComponent>
            </div>
        </>
    );
};

export default DialogContentClone;
